export const FETCH_LOGS_REQUEST = 'FETCH_LOGS_REQUEST';
export const FETCH_LOGS_SUCCESS = 'FETCH_LOGS_SUCCESS';
export const FETCH_LOGS_FAILURE = 'FETCH_LOGS_FAILURE';

export const FETCH_LOGS_DATE_CHART_REQUEST = 'FETCH_LOGS_DATE_CHART_REQUEST';
export const FETCH_LOGS_DATE_CHART_SUCCESS = 'FETCH_LOGS_DATE_CHART_SUCCESS';
export const FETCH_LOGS_DATE_CHART_FAILURE = 'FETCH_LOGS_DATE_CHART_FAILURE';

export const FETCH_LOGS_TYPE_CHART_REQUEST = 'FETCH_LOGS_TYPE_CHART_REQUEST';
export const FETCH_LOGS_TYPE_CHART_SUCCESS = 'FETCH_LOGS_TYPE_CHART_SUCCESS';
export const FETCH_LOGS_TYPE_CHART_FAILURE = 'FETCH_LOGS_TYPE_CHART_FAILURE';

export const FETCH_LOGS_FILTER_REQUEST = 'FETCH_LOGS_FILTER_REQUEST';
export const FETCH_LOGS_FILTER_SUCCESS = 'FETCH_LOGS_FILTER_SUCCESS';
export const FETCH_LOGS_FILTER_FAILURE = 'FETCH_LOGS_FILTER_FAILURE';